export const randomValueBetween = (min = 1, max = 100) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const formatCurrency = (currency, includeCents = true) =>
  typeof currency === 'number'
    ? formatNegativeNumber(
        new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          ...(!includeCents && { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
        }).format(currency),
      )
    : formatNegativeNumber(currency);

export const isNumbersOnly = (value) => {
  const re = /^[0-9\b]+$/;
  return re.test(value);
};

export const formatNegativeNumber = (number) => {
  return number ? (number.indexOf('-') >= 0 ? number.replace('-', '(').concat(')') : number) : '';
};

export const formatWithCommas = (n) => (typeof n === 'number' ? n.toLocaleString(n) : n);
